import { RegisterForm } from '@/components/auth/RegisterForm'

export function RegisterPage() {
  return <RegisterForm />
}
